import { call, put, takeLatest } from 'redux-saga/effects';
import { AFFORDABILITY_TABLE_DATA_REQUEST, MPIN_TABLE_DATA_REQUEST } from '../actions/actionTypes';
import { getDdpData } from '@src/apps/DDPLabAndImaging/Main/Main.service';
import { fetchDdpDataError, fetchDdpDataSuccess } from '../actions/affordabilityActions/ddpAction';
import { setMPINTableDataError, setMPINTableDataLoading, setMPINTableDataSuccess } from '../actions/affordabilityActions/affordabilityCommonActions';
import { getRadiologyTableData } from '@src/apps/RadiologyAndCardiology/Main/Main.service';
import { affordabililityStateKeys } from '@src/CommonComponents/constant/constant';
import { getMedicationTableData } from '@src/apps/AffordablitySummaryMedSourcing/Main/Main.service';

const getServiceMethod = (key: string) => {
  switch (key) {
    case affordabililityStateKeys.radiologyTableData:
      return getRadiologyTableData;
    case affordabililityStateKeys.medSourcingTableData:
        return getMedicationTableData;
    default:
      return getRadiologyTableData;
  }
}
export function* fetchDDPData(action: any) {
  try {
    const response = yield call(getDdpData, action?.payload);
    if (response) {
      yield put(fetchDdpDataSuccess(response?.Data));
    }

  } catch (error) {
    yield put(fetchDdpDataError(error));
  }
}
export function* fetchAffordabilityMPINTableData(action: any) {
  try {
    yield put(setMPINTableDataLoading(true, action?.key + 'Loading'));
    const response = yield call(getServiceMethod(action.key), action?.payload);
    yield put(setMPINTableDataLoading(false, action?.key + 'Loading'));
    if (response) {
      yield put(setMPINTableDataSuccess(response?.Data, action?.key));
    }

  } catch (error) {
    yield put(setMPINTableDataError(error, action?.key + 'Loading'));
  }
}


export function* affordabilitySaga() {
  yield takeLatest(MPIN_TABLE_DATA_REQUEST, fetchDDPData);
  yield takeLatest(AFFORDABILITY_TABLE_DATA_REQUEST, fetchAffordabilityMPINTableData);
}


export default [affordabilitySaga];
